import { useSyncExternalStore } from "react";
import { resolvePrimaryEnvironmentHttpUrl } from "../environments/primary/target";

// Shared across the overview and per-change composers, including before polling
// has observed a just-submitted run. Never allow one composer to race another.
const pending = new Map<string, string>();
const listeners = new Set<() => void>();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export const findingControlKey = (organizationId: string, findingId: string) =>
  JSON.stringify([organizationId, findingId]);
export function setPendingFindingRun(key: string, threadId: string | null) {
  if (threadId === null) pending.delete(key);
  else pending.set(key, threadId);
  for (const listener of listeners) listener();
}
export function usePendingFindingRun(key: string) {
  return useSyncExternalStore(
    subscribe,
    () => pending.get(key) ?? null,
    () => null,
  );
}
/** Where Inspector is asked about a finding or a suggestion, and how that item's id is named. */
export const reviewEndpoint = (
  subject: "finding" | "suggestion",
  organizationId: string,
  id: string,
  stop = false,
) =>
  resolvePrimaryEnvironmentHttpUrl(
    `/api/amoreg/inspector/${subject}-review${stop ? "/stop" : ""}`,
    subject === "suggestion"
      ? { organizationId, recommendationId: id }
      : { organizationId, findingId: id },
  );
export async function stopFindingInspector(
  organizationId: string,
  findingId: string,
  threadId: string,
  subject: "finding" | "suggestion" = "finding",
) {
  try {
    const response = await fetch(
      reviewEndpoint(subject, organizationId, findingId, true),
      {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ threadId }),
      },
    );
    return response.ok ? null : "Inspector could not be stopped. Try again.";
  } catch {
    return "Inspector could not be reached. Try stopping again.";
  }
}
